<script setup lang="ts">
import { mdiGiftOutline } from '@mdi/js'
import giftImage from '@/assets/images/EmporiumIcon_Gift.webp'

const emit = defineEmits<{
  (e: 'click' | 'submit'): void
}>()

const onClick = () => {
  emit('click')
}

const onSubmit = () => {
  emit('submit')
}
</script>

<template>
  <v-card
    class="gift-card glow-border-cycle"
    :ripple="false"
    @click="onClick"
  >
    <div class="gift-card-inner d-flex flex-column ga-1">
      <div class="flex-grow-0">
        <v-img
          :src="giftImage"
          aspect-ratio="1"
          cover
          class="gift-image"
        >
          <div class="overlay-text">
            <p>ギフト受け取り</p>
          </div>
        </v-img>
      </div>
      <div class="flex-grow-1 gift-description">
        <p>ギフトカードのキーを入力して特典を受け取れます。</p>
      </div>
    </div>
    <v-card-actions>
      <v-btn
        size="large"
        variant="elevated"
        color="amber-darken-4"
        class="text-white"
        @click.stop="onSubmit"
      >
        <v-icon>{{ mdiGiftOutline }}</v-icon>
        キーを入力
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.gift-card {
  width: 100%;
  aspect-ratio: 7 / 7.2;
  background: linear-gradient(135deg, #4a3728 0%, #6b4c3b 50%, #4a3728 100%);
  box-shadow: 7px 7px 5px #00000060;
  padding: max(4.44px, calc(0.625 * var(--u)));
  border-radius: 8px;
  border: 1px dashed rgba(255, 215, 0, 0.5);

  cursor: pointer;
  user-select: none;
  position: relative;
  overflow: visible;

  font-family: "Noto Sans JP", sans-serif !important;
}

.gift-card:hover {
  border-color: rgba(255, 215, 0, 0.9);
}

.gift-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.gift-image {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: contain;
  border-radius: 6px;
}

.overlay-text {
  position: absolute;
  top: 45%;
  left: 50%;
  width: 90%;
  transform: translate(-50%, -50%);
  font-size: max(13.33px, calc(1.875 * var(--u)));
  font-weight: bold;
  text-align: center;
  color: #000;
  text-shadow:
    1px 1px 0 #fff,
    -1px -1px 0 #fff,
    -1px 1px 0 #fff,
    1px -1px 0 #fff,
    0px 1px 0 #fff,
    0 -1px 0 #fff,
    -1px 0 0 #fff,
    1px 0 0 #fff;
}

.gift-description {
  font-size: max(8.33px, calc(1.17 * var(--u)));
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
}

.gift-card .v-card-actions {
  padding: 0;
  min-height: 0;
}

.gift-card .v-btn {
  width: 100%;
  height: max(28px, calc(3.75 * var(--u)));
  min-height: 0;
  font-size: max(13.33px, calc(1.875 * var(--u)));
}

.gift-card .v-btn :deep(.v-icon) {
  font-size: max(13.33px, calc(1.875 * var(--u)));
}

/* Grow エフェクト */
.glow-border-cycle {
  position: relative;
  overflow: visible;
}

.glow-border-cycle::before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 10px;
  border-radius: inherit;

  background: linear-gradient(
    90deg,
    transparent,
    #FF7F18E0,
    transparent
  );
  background-size: 200% 100%;

  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  -webkit-mask-composite: xor;

  pointer-events: none;

  animation: border-glow-cycle 3.5s linear infinite;
  opacity: 0;
}

@keyframes border-glow-cycle {
  0% {
    background-position: 0% 50%;
    opacity: 0;
  }

  10% {
    opacity: 1;
  }

  40% {
    background-position: 200% 50%;
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    background-position: 200% 50%;
    opacity: 0;
  }
}
</style>
